var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 40,
    viewBox: "0 0 150 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1361 29.0186H43.0469V39.0687H55.7667V33.9983H48.1361V29.0186Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1873 19.9386H37.5502V15.0299H45.1873V0.0646973H32.4609V5.13503H40.098V10.0695H32.4609V25.0089H45.1873V19.9386Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1117 12.9019H18.7468C17.6345 8.90512 13.9615 5.95604 9.60295 5.93664V10.2115C10.7605 10.2244 10.4759 12.5009 11.4265 13.18C12.3771 13.8526 14.4659 12.8825 14.8345 13.9948C15.1772 15.0813 12.9139 15.5341 12.5517 16.64C12.209 17.7523 13.7804 19.4273 12.8298 20.1064C11.8792 20.779 10.7669 18.7742 9.60295 18.7677V24.9245C13.9615 24.8987 17.6345 21.956 18.7468 17.9528H23.1117V24.9245H28.8476V5.93018H23.1117V12.8954V12.9019ZM9.60295 5.93018H9.55122C4.29384 5.93018 0 10.1856 0 15.4112C0 20.6367 4.28738 24.9181 9.55122 24.9181H9.60295V18.7612H9.59648C8.43249 18.7612 7.30729 20.779 6.36317 20.0999C5.43197 19.4209 6.99043 17.7459 6.64123 16.6335C6.27263 15.5211 4.00931 15.0749 4.37791 13.9884C4.72064 12.876 6.83523 13.8526 7.75996 13.1735C8.71055 12.4944 8.42602 10.205 9.59002 10.205H9.59648V5.93018H9.60295Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1553 5.93018H50.4453V24.918H56.1553V5.93018Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.516 5.93054V11.4277C129.715 11.4277 131.525 13.2127 131.525 15.4115C131.525 17.6104 129.715 19.4148 127.516 19.4148V24.9119C132.773 24.9119 137.067 20.6565 137.067 15.4051C137.067 10.1537 132.773 5.92407 127.516 5.92407V5.93054ZM127.516 5.93054C122.252 5.93054 117.965 10.186 117.965 15.4115C117.965 20.6371 122.252 24.9184 127.516 24.9184V19.4212C125.298 19.4212 123.507 17.6104 123.507 15.418C123.507 13.2256 125.298 11.4342 127.516 11.4342V5.93701V5.93054Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.425 14.713H111.848V9.64268H102.51V5.07033H111.848V0H97.4208V14.713H102.335V19.2854H95.332V24.3557H114.415V19.2854H107.425V14.713Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.992 39.9998C109.319 39.9998 112.849 36.7274 112.849 32.6918C112.849 28.6562 109.319 25.4032 104.992 25.3967V29.8074C106.693 29.8074 108.096 31.1009 108.096 32.6918C108.096 34.2827 106.693 35.5891 104.992 35.5891V39.9998ZM104.992 25.4032C100.66 25.4032 97.1289 28.6756 97.1289 32.6983C97.1289 36.7209 100.66 40.0063 104.992 40.0063V35.5956C103.272 35.5956 101.888 34.2827 101.888 32.6983C101.888 31.1138 103.162 29.8139 104.992 29.8139V25.4032Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8735 5.93054V11.4277C72.0915 11.4277 73.8828 13.2127 73.8828 15.4115C73.8828 17.6104 72.0915 19.4148 69.8735 19.4148V24.9119C75.1309 24.9119 79.4247 20.6565 79.4247 15.4051C79.4247 10.1537 75.1309 5.92407 69.8735 5.92407V5.93054ZM69.8735 5.93054C64.6161 5.93054 60.3223 10.186 60.3223 15.4115C60.3223 20.6371 64.6096 24.9184 69.8735 24.9184V19.4212C67.6748 19.4212 65.8642 17.6104 65.8642 15.418C65.8642 13.2256 67.6748 11.4342 69.8735 11.4342V5.93701V5.93054Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.128 12.9019V5.93018H139.418V24.918H145.128V17.9463H149.997V12.9019H145.128Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9195 5.93018H84.1836V24.918H89.9195V5.93018Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo_black.6e21178e7093b2af8d4309f079591f6a.svg";
export { ForwardRef as ReactComponent };